export default __webpack_public_path__ + "static/media/Bezel_Black_Light_Green.7594569b.png";